// extracted by mini-css-extract-plugin
export var listTitle = "index-module--listTitle--9a97f";
export var socialsColumn = "index-module--socialsColumn--a0bd9";
export var socialsList = "index-module--socialsList--0829e";